module.exports = __webpack_public_path__ + "images/681bf7d41d79c3d638dabbc3d48f62f652ed5f4e35792af3482b9faf9156b70d.svg";